fragment FromAddress on FromAddress {
    id
    status
    emailAddress {
        address
        display
        formatted
    }
    sesMailfromStatus
    fromDomain {
        id
        sesDkimStatus
        nutshellMailfromStatus
        nutshellDkimStatus
        refreshedNutshellDkimStatus
        refreshedDmarcStatus
    }
}
